import state from './endpointState'
import mutations from './endpointMutations'
import getters from './endpointGetters'
import actions from './endpointActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
